var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { each, mapValues } from "lodash";
import FeatureFlagValues from "../enums/featureFlags";
export function defaultFlags() {
    var flags = mapValues(FeatureFlagValues, function () {
        /**
         * @desc: Loop through all FeatureFlagValues enum and set a value
         * @example: To set one key to true:
         *  | const flags: FeatureFlags = mapValues(FeatureFlagValues, (key) => {
         *  |   if (key === FeatureFlagValues.isCoolThing) { // should default to true
         *  |     return true
         *  |   }
         *  |   return false
         *  | })
         */
        return false;
    });
    return flags;
}
export function getFeatureFlag(userTenant, flag) {
    var obj = stringToObject(userTenant);
    return obj[flag];
}
export function setFeatureFlag(userTenant, flag, value) {
    var obj = stringToObject(userTenant);
    obj[flag] = value;
    userTenant.settings.featureFlags = objectToString(obj);
}
/** @description: Helper functions to turn feature flags string into object
 *  @todo: Will change when we create a proper featureFlag service
 */
export function stringToObject(userTenant) {
    try {
        var raw_1 = __assign(__assign({}, defaultFlags()), JSON.parse(userTenant.settings.featureFlags));
        // removing old feature flags not in the typing
        var picked_1 = {};
        each(FeatureFlagValues, function (_value, key) {
            picked_1[key] = raw_1[key];
        });
        return picked_1;
    }
    catch (e) {
        return defaultFlags();
    }
}
function objectToString(featureFlags) {
    try {
        return JSON.stringify(featureFlags) || "";
    }
    catch (e) {
        return JSON.stringify(defaultFlags());
    }
}
